export function format_phone(input) {
  // Strip out all non-numeric characters
  const digits = input.replace(/\D/g, "");

  // Break down the digits into parts
  const areaCode = digits.slice(0, 3);
  const firstPart = digits.slice(3, 6);
  const secondPart = digits.slice(6, 10);

  let formatted = "";

  // Start building the formatted number
  if (areaCode) {
    formatted += `(${areaCode}`;
    if (areaCode.length === 3) formatted += ")";
  }

  if (firstPart) {
    formatted += `${areaCode.length === 3 ? " " : ""}${firstPart}`;
  }

  if (secondPart) {
    formatted += `-${secondPart}`;
  }

  return formatted;
}

export function format_phone_for_link(input) {
  // Remove all non-numeric characters
  const digits = input.replace(/\D/g, "");

  // Return in the "tel:+..." format
  return `tel:+1${digits}`;
}
